document.addEventListener("DOMContentLoaded", function () {
  const buttons = document.querySelectorAll(".add-to-cart-archive-button");

  buttons.forEach(function (button) {
    button.addEventListener("click", function (e) {
      e.preventDefault();

      // Pobieranie ID (najpierw z data-product_id, potem z href)
      let product_id = this.dataset.product_id;
      if (!product_id) {
        const urlParams = new URLSearchParams(
          this.getAttribute("href").split("?")[1],
        );
        product_id = urlParams.get("add-to-cart");
      }

      if (!product_id) {
        console.error("Nie udało się odnaleźć ID produktu.");
        return;
      }

      const formData = new FormData();
      formData.append("action", "woocommerce_add_to_cart");
      formData.append("product_id", product_id);
      formData.append("quantity", 1);

      // DODANIE NONCE (SECURITY)
      if (
        typeof wc_add_to_cart_params !== "undefined" &&
        wc_add_to_cart_params.nonce
      ) {
        formData.append("security", wc_add_to_cart_params.nonce);
      }

      fetch(wc_add_to_cart_params.ajax_url, {
        method: "POST",
        body: formData,
      })
        .then((response) => response.json())
        .then((data) => {
          // Sprawdzamy, czy serwer nie zwrócił błędu (np. brak ID w wersji DE)
          if (data.error) {
            console.error("Błąd WooCommerce:", data);
            if (data.product_url) {
              window.location.href = data.product_url;
            }
            return;
          }

          // Obsługa sukcesu
          const originalText = button.innerHTML;
          const isDe = document.documentElement.lang.includes("de");

          button.innerText = isDe
            ? "In den Warenkorb gelegt!"
            : "Dodano do koszyka!";

          setTimeout(() => {
            button.innerHTML = originalText;
          }, 8000);

          // Odświeżenie fragmentów (ikonki i koszyka)
          document.body.dispatchEvent(new CustomEvent("wc_fragment_refresh"));

          const modal = document.querySelector(".xoo-wsc-modal");
          if (modal) {
            modal.classList.add("xoo-wsc-cart-active");
          }
        })
        .catch((error) => console.error("Błąd połączenia AJAX:", error));
    });
  });
});
